import { render, staticRenderFns } from "./commission.vue?vue&type=template&id=0472d1ba&scoped=true&"
import script from "./commission.vue?vue&type=script&lang=ts&"
export * from "./commission.vue?vue&type=script&lang=ts&"
import style0 from "@/modules/CarrierProduct/styles/carrier-product-detail-table.scss?vue&type=style&index=0&id=0472d1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0472d1ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
